/*  MUI  */
import { Box, Tab } from '@mui/material';

/* Shared */
import { PageTitle } from 'application/Shared/Components/App';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router';

export const SetupReportViewHeaderTabs = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const urlTab = searchParams.get('tab');
    const currentTab = urlTab || 'reportSetup';

    return (
        <Box data-trackid="setupReportViewHeaderTabs">
            <Box>
                {currentTab === 'reportSetup' && (
                    <PageTitle title={t('Reports.report_setup')} />
                )}
                {currentTab === 'myReports' && ( // My reports === Scheduled reports
                    <PageTitle title={t('Reports.my_reports')} />
                )}
            </Box>

            <Box>
                <MUITabsWrapper value={currentTab}>
                    <Tab
                        component={Link}
                        to="?tab=reportSetup"
                        value="reportSetup"
                        label={t('Reports.report_setup')}
                        aria-label="report-setup"
                    />
                    <Tab
                        component={Link}
                        to="?tab=myReports"
                        value="myReports"
                        label={t('Reports.my_reports')}
                        aria-label="scheduled-reports"
                    />
                </MUITabsWrapper>
            </Box>
        </Box>
    );
};
